import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromCms from './cms.reducer';
import { CmsEffects } from './cms.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromCms.cmsFeatureKey, fromCms.reducers, {
            metaReducers: fromCms.metaReducers,
        }),
        EffectsModule.forFeature([CmsEffects]),
    ],
})
export class CmsModule {}

export * as CmsActions from './cms.actions';
export * as CmsSelectors from './cms.selectors';
